<template>
    <div class="mobile-back-btn-secondary-nav-container">
        <router-link
            v-slot="{ href, route, navigate, isActive, isExactActive }"
            :to="{ name: 'FileList', params: { uuid: id } }"
        >
            <div @click="navigate" class="mobile-back-btn-secondary-nav primaryBg">
                <i class="fa lh-inherit fa-arrow-left"></i> {{ 'Back' | trans }}
            </div>
        </router-link>
        <div class="mobile-back-btn-secondary-nav primaryBg" v-bind:title="'Download' | trans" @click.stop="download()">
            <i class="far fa-download lh-inherit"></i> {{ 'Download' | trans }}
        </div>
        <div v-if="isCopyClicked" class="mobile-back-btn-secondary-nav copied-text-success">
            <i class="far fa-check-circle font-size-110"></i>
            <div>{{ 'Copied!' | trans }}</div>
        </div>
        <div v-else class="mobile-back-btn-secondary-nav file-action-btn" @click.prevent="copyText">
            <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M7.8 15.3C7.36 15.3 6.98347 15.1435 6.6704 14.8304C6.35733 14.5173 6.20053 14.1405 6.2 13.7V4.1C6.2 3.66 6.3568 3.28347 6.6704 2.9704C6.984 2.65733 7.36053 2.50053 7.8 2.5H15C15.44 2.5 15.8168 2.6568 16.1304 2.9704C16.444 3.284 16.6005 3.66053 16.6 4.1V13.7C16.6 14.14 16.4435 14.5168 16.1304 14.8304C15.8173 15.144 15.4405 15.3005 15 15.3H7.8ZM7.8 13.7H15V4.1H7.8V13.7ZM4.6 18.5C4.16 18.5 3.78347 18.3435 3.4704 18.0304C3.15733 17.7173 3.00053 17.3405 3 16.9V6.5C3 6.27333 3.0768 6.08347 3.2304 5.9304C3.384 5.77733 3.57387 5.70053 3.8 5.7C4.02667 5.7 4.2168 5.7768 4.3704 5.9304C4.524 6.084 4.60053 6.27387 4.6 6.5V16.9H12.6C12.8267 16.9 13.0168 16.9768 13.1704 17.1304C13.324 17.284 13.4005 17.4739 13.4 17.7C13.4 17.9267 13.3232 18.1168 13.1696 18.2704C13.016 18.424 12.8261 18.5005 12.6 18.5H4.6Z"
                    fill="#2E2E2E"
                />
            </svg>
            <div>{{ 'Copy' | trans }}</div>
        </div>
    </div>
</template>
<script>
import store from '../../../mixins/store.mixin';
import currentJob from '../../../mixins/current_job.mixin';
import DownloadManager from '../../../manager/DownloadManager';
import CopyUrlContentToClipboard from '../../../manager/CopyUrlContentToClipboard';

export default {
    name: 'MobileTxtBackBtnSecondaryNav',
    props: {},
    components: {},
    mixins: [store, currentJob],
    data() {
        return { isCopyClicked: false };
    },
    mounted: function () {},
    created: function () {},
    methods: {
        download() {
            DownloadManager.downloadOutput(this.currentOutput, this.currentJob);
        },
        async copyText() {
            const response = await CopyUrlContentToClipboard.copy(this.currentOutput.uri);
            if (response) {
                this.isCopyClicked = true;
            }
            setTimeout(() => {
                this.isCopyClicked = false;
            }, 2000);
        },
    },
    computed: {},
};
</script>
<style lang="scss" scoped>
.mobile-back-btn-secondary-nav-container {
    border-top: 1px solid #cbcbcb;
    background: white;
    padding: 10px 20px !important;
    display: flex;
    gap: 10px;

    .mobile-back-btn-secondary-nav {
        width: 100%;
        color: white;
        height: 55px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        font-size: 17.5px;
        font-weight: 600;
        cursor: pointer;
        flex-direction: column;
        padding: 5px 0;
        line-height: 1.3;
    }
    .primaryBg {
        background: #1266f1;
        &:hover {
            background: #1161e5;
        }
    }
    .copied-text-success {
        background: #ccf4dc;
        border: 1px solid #cbcbcb;
        color: #0b7335;
    }
    .file-action-btn {
        cursor: pointer;
        background: #f2f2f2;
        border: 1px solid #cbcbcb;
        color: #323232;

        .dark-mode & {
            background: #383838;
            border: 1px solid #595959;
            color: white;

            &:hover {
                background: #323232;
            }
        }
    }
}
</style>
